import React from 'react'
import styled from "styled-components";
import TranslateText from 'src/text/modal';


const TextContainer = styled.div`
  
`

const AdvantagesContainer = styled.div`
  margin-top: 40px;
`

function CategoryText({characteristics, advantages}) {
  return (
    <TextContainer>

      {
        characteristics &&
        <div style={{marginTop: 40}}>
          <div
            style={{
              fontSize: 16,
            }}
          >
            <div
              style={{
                fontSize: 20,
                fontWeight: 800,
                marginBottom: 40,
              }}
            >
              <TranslateText id="catalogue__main_characteristics" />
            </div>
            <TranslateText
              id={characteristics}
              controls={['ul']}
              useHtml
            />
          </div>
        </div>
      }

      {
        advantages &&
        <AdvantagesContainer>
          <div
            style={{
              fontSize: 20,
              fontWeight: 800,
              marginBottom: 40,
            }}
          >
            <TranslateText id="catalogue__additional_benefits" />
          </div>
          <TranslateText
            id={advantages}
            useHtml
            controls={['ul']}
            render={html => {
              const regex = /\<li\>(.*)\<\/li\>/gm
              let match
              let advantagesList = []
              let isError = true
              try {
                while ((match = regex.exec(html)) != null) {
                  isError = false
                  advantagesList.push(match[1]);
                }
              } catch (e) {
                isError = true
              }
              if (isError) {
                advantagesList = [html]
              }
              return (
                <ul>
                  {(advantagesList || []).map(a => {
                    return (
                      <li style={{marginTop: 10}}>
                          {a}
                      </li>
                    )
                  })}
                </ul>
              )
            }}
          />
        </AdvantagesContainer>
      }
    </TextContainer>
  );
}

export default CategoryText



// WEBPACK FOOTER //
// ./src/finwhale/common/category/text/Desktop.js